import { render, staticRenderFns } from "./campaigns-page-wrapper.vue?vue&type=template&id=9ed3a2b2&scoped=true&lang=html&"
import script from "./campaigns-page-wrapper.vue?vue&type=script&lang=js&"
export * from "./campaigns-page-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./campaigns-page-wrapper.vue?vue&type=style&index=0&id=9ed3a2b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed3a2b2",
  null
  
)

export default component.exports